import React from "react";

function Mountain({ color }) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1018_1779)">
        <path
          d="M39.6825 32.9188L21.6825 4.91875C21.3144 4.34625 20.6806 4 20 4C19.3194 4 18.6856 4.34625 18.3175 4.91875L0.317498 32.9188C0.12325 33.2209 0.0139528 33.5698 0.00108561 33.9287C-0.0117815 34.2877 0.0722567 34.6435 0.244373 34.9587C0.41657 35.2739 0.670456 35.537 0.979371 35.7202C1.28829 35.9034 1.64084 36 2 36H38C38.7319 36 39.405 35.6006 39.7556 34.9581C39.9277 34.643 40.0118 34.2873 39.9989 33.9284C39.986 33.5695 39.8767 33.2208 39.6825 32.9188ZM20 9.69875L25.3369 18H20L16 22L13.6212 19.6213L20 9.69875Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1018_1779">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Mountain;
